import styled from "styled-components";
import Variables from "../styleVariables";

export const Header = styled.div`
  height: 63px;
  padding: 24px 32px 16px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  h1 {
    font-size: ${Variables.font_sizes.x2_large};
    color: ${Variables.colors.complementary_800};
    margin: 0;
    text-align: right;
    font-weight: ${Variables.font_weight.regular};
  }
  .header-icon {
    margin-left: 12px;
    &:before {
      color: ${Variables.colors.red_500};
      font-size: 20px;
    }
  }
`;
export const Body = styled.div`
  padding: 16px 32px;
  min-height: 68px;
  line-height: 1.58;
  position: relative;
  p {
    color: ${Variables.colors.complementary_700};
    max-width: 65%;
    width: 100%;
    font-size: ${Variables.font_sizes.x_small};
    margin: 0 0 24px 0;
    a {
      color: ${Variables.colors.primary_vivid};
      text-decoration: none;
      cursor: pointer;
      &:visited,
      &:focus {
        color: ${Variables.colors.primary_vivid};
      }
      &:hover {
        color: ${Variables.colors.primary_vivid};
        text-decoration: underline;
      }
    }
    a.more {
      margin-right: 8px;
      font-size: ${Variables.font_sizes.x_medium};
      color: ${Variables.colors.primary_vivid};
      text-decoration: none;
      &:visited,
      &:hover,
      &:focus {
        color: ${Variables.colors.primary_vivid};
      }
    }
  }
  .exit-container {
    display: flex;
    justify-content: space-between;
  }
  img {
    position: absolute;
    left: 0;
    top: -45px;
    min-width: 118px;
    max-height: 130%;
  }
  table td {
    cursor: pointer;
    &.name {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 500px;
    }
  }
`;
export const Footer = styled.div`
  height: 63px;
  border-top: 1px solid ${Variables.colors.complementary_400};
  padding: 16px 32px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .text {
    color: ${Variables.colors.complementary_900};
    font-size: ${Variables.font_sizes.x_medium};
    margin-left: 42px;
  }
  a,
  .edit-link,
  button {
    cursor: pointer;
    border: 0;
    text-decoration: none;
    color: ${Variables.colors.primary_vivid};
    font-size: ${Variables.font_sizes.x_medium};
    font-weight: ${Variables.font_weight.medium};
    margin-left: 42px;
    background-color: ${Variables.colors.complementary};
    display: flex;
    align-items: center;
    &:focus,
    &:visited,
    &:hover {
      color: ${Variables.colors.primary_vivid};
    }
  }
`;
export const Grid = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  .row {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    min-height: 22px;
    margin-bottom: 8px;
    .title {
      max-width: 224px;
      width: 100%;
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_700};
      font-weight: ${Variables.font_weight.medium};
    }
    .value {
      width: 100%;
      max-width: 420px;
      font-size: ${Variables.font_sizes.x_medium};
      color: ${Variables.colors.complementary_900};
      &.reverse {
        direction: ltr;
      }
    }
    .inline {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
    }
    .api-token {
      cursor: pointer;
    }
  }

  .reverse-row {
    width: 100%;
    display: flex;
    align-items: flex-end;
    flex-direction: row-reverse;
    flex-wrap: nowrap;
    min-height: 22px;
    margin-bottom: 8px;

    .inline {
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: center;
    }
  }

  .message-box-p {
    font-size: 14px;
    display: flex;
    gap: 2px;

    .title {
      font-weight: bold;
      padding-left: 2px;
    }
  }
`;

export const BoxContainer = styled.div`
  min-width: 838px;
  width: 100%;
  -webkit-box-shadow: 0 0 2px 0 #ccc;
  -moz-box-shadow: 0 0 2px 0 #ccc;
  box-shadow: 0 0 2px 0 #ccc;
  border: 1px solid ${Variables.colors.complementary_400};
  border-radius: 4px;
  margin: 0 auto 32px auto;
  position: relative;
  min-height: ${props =>
    props.minHeight !== undefined ? `${props.minHeight}px` : "auto"};
  .my-project-rows {
    max-height: 220px;
    overflow-y: auto;
  }
  table {
    margin-right: 32px;
    width: calc(100% - 32px);
    thead,
    tbody {
      a,
      tr {
        cursor: pointer;
        &:last-child {
          td {
            border-bottom: 0 !important;
          }
        }
        td,
        th {
          padding: 8px;
        }
        .plan-detail {
          width: calc(40%);
          max-width: 230px;
          word-wrap: break-word;
        }
        .payment-status,
        .payment-date {
          width: calc(13%);
          max-width: 112px;
          overflow: hidden;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .project-name {
          max-width: 88px;
          width: calc(13%);
          word-wrap: break-word;
        }
        .payment-amount {
          width: calc(19%);
          max-width: 120px;
          word-wrap: break-word;
        }
      }
    }
  }
`;

export const SmallBoxContainer = styled(BoxContainer)`
  width: 50%;
  min-width: 403px;
  margin-left: 32px;

  &:last-child {
    margin-left: 0;
  }
  .contacts-container {
    height: 221px;
    overflow-y: auto;
  }
`;

export const FormBox = styled(BoxContainer)`
  width: calc(100% - 444px);
`;

export const SettingTitle = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  h1 {
    color: ${Variables.colors.complementary_800};
    font-size: ${Variables.font_sizes.x4_large};
    font-weight: ${Variables.font_weight.medium};
    margin: 0 0 32px 0;
  }
  h5 {
    color: ${Variables.colors.complementary_700};
    font-size: ${Variables.font_sizes.x2_medium};
    font-weight: ${Variables.font_weight.regular};
    margin: 0 0 32px 0;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : "center"};
  //align-items: flex-start;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${props => (props.mr ? props.mr + "px" : "")};
  flex: 1;
  //align-items: flex-start;
  & > div {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const BoxContainerColumn = styled.div`
  width: calc(100% - 32px);
  min-height: 68px;
  margin-right: 32px;
  padding: 18px 0 18px 32px;
  border-top: 1px solid ${Variables.colors.complementary_400};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  & > div {
  }
`;
export const BoxContainerRow = styled.div`
  width: calc(100% - 32px);
  min-height: 68px;
  margin-right: 32px;
  padding: 18px 0 18px 32px;
  border-top: 1px solid ${Variables.colors.complementary_400};
  display: flex;
  justify-content: flex-start;
  align-items: center;

  &:first-child {
    border-top: 0;
  }

  .project-basic-input {
    min-width: 300px;
    color: ${props =>
      props.disabled ? Variables.colors.complementary_600 : "auto"};

    &.reverse {
      direction: ltr;
    }
  }

  .project-basic-username {
    width: 250px;
    margin-left: 8px;

    &:last-child {
      margin-left: 0;
    }
  }

  .project-basic-info-select-box {
    min-width: 172px;
  }

  textarea {
    min-width: 412px;
  }
`;
export const Label = styled.label`
  font-size: ${Variables.font_sizes.x_small};
  font-weight: ${Variables.font_weight.medium};
  color: ${Variables.colors.complementary_700};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 212px;
  .required {
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      font-size: 8px;
      margin: 0;
      color: ${Variables.colors.red_600};
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  left: 24px;
  bottom: 24px;
  button:first-child {
    margin-left: 8px;
  }
`;

export const FormContainer = styled.div`
  min-width: 838px;
  width: calc(100% - 444px);
  margin: 0 auto;
  position: relative;
  padding-bottom: 72px;
  form {
    -webkit-box-shadow: 0 0 2px 0 #ccc;
    -moz-box-shadow: 0 0 2px 0 #ccc;
    box-shadow: 0 0 2px 0 #ccc;
    border: 1px solid ${Variables.colors.complementary_400};
    border-radius: 4px;
  }
`;
